import axios from "@/libs/axios";

export const getMetrics = async () => {
  const response = await axios.get("/dashboard/metrics");
  return response.data;
};
